import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { KomodoCoreWrappersModule } from '@komodo-design-system/komodo-core-angular-twelve-wrappers/dist/komodo-core-wrappers';
import { use } from 'echarts/core';
import { NgxEchartsDirective, NgxEchartsModule, provideEchartsCore } from 'ngx-echarts';

import { DrilldownChartNoDataAvailableModule } from '../drilldown-chart-no-data-available/drilldown-chart-no-data-available.module';
import { TimeCycleChartComponent } from './time-cycle-chart.component';
import { TimeCycleChartTooltipComponent } from './time-cycle-chart-tooltip/time-cycle-chart-tooltip.component';

@NgModule({
  declarations: [TimeCycleChartComponent, TimeCycleChartTooltipComponent],
  exports: [TimeCycleChartComponent],
  imports: [
    BrowserModule,
    NgxEchartsDirective,
    NgxEchartsModule.forRoot({
      echarts: {
        use
      }
    }),
    DrilldownChartNoDataAvailableModule,
    KomodoCoreWrappersModule
  ],
  providers: [
    provideEchartsCore({
      echarts: {
        use
      }
    })
  ]
})
export class TimeCycleChartModule {}
